import { Controller } from "@hotwired/stimulus";

// Two-way link between a brand checkbox (the "all établissements" toggle) and its stores checkboxes
export default class extends Controller {
  static targets = ["allStores", "store"];

  connect() {
    this.syncFromStores();
  }

  toggleAll() {
    this.storeTargets.forEach((store) => {
      store.checked = this.allStoresTarget.checked;
    });
  }

  syncFromStores() {
    if (!this.hasStoreTarget) return;

    const all = this.storeTargets.every((store) => store.checked);
    const some = this.storeTargets.some((store) => store.checked);
    this.allStoresTarget.checked = all;
    this.allStoresTarget.indeterminate = some && !all;
  }
}
